/**
 * Format a byte count as a human-readable size string.
 *
 * - Scales through B / KB / MB / GB / TB / PB (binary 1024 steps).
 * - Returns `fallback` ("0 B" by default) for null, undefined, non-finite,
 *   zero and negative inputs — a missing size is not a rendering error.
 * - Drops the decimal for whole bytes and for values of 100 and above, where
 *   the extra digit is noise.
 */
export function formatFileSize(
  bytes: number | null | undefined,
  options: { fallback?: string } = {},
): string {
  const { fallback = "0 B" } = options;
  if (bytes == null || !Number.isFinite(bytes) || bytes <= 0) return fallback;
  const units = ["B", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** i;
  return `${value.toFixed(value >= 100 || i === 0 ? 0 : 1)} ${units[i]}`;
}
